import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53de4562"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Código Interno")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "00000001")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Descrição")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "DESCRIÇÃO DO PRODUTO 1")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Unidade principal")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "DESCRIÇÃO DO PRODUTO 1")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Marca")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "DESCRIÇÃO DO PRODUTO 1")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Categoria")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "DESCRIÇÃO DO PRODUTO 1")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Tipo")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "DESCRIÇÃO DO PRODUTO 1")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "NCM")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "DESCRIÇÃO DO PRODUTO 1")
    ])
  ])
], -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_4 = {
  class: "custom-slick-arrow",
  style: {"left":"10px","z-index":"1"}
}
const _hoisted_5 = {
  class: "custom-slick-arrow",
  style: {"right":"10px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "1")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "2")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "3")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "4")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes-titulo" }, "ESTOQUE/DISPONIBILIDADE")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Empresa")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Estoque")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza ss-produto-detalhes-alinhar-direita" }, "Quantidade disponível")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza ss-produto-detalhes-alinhar-direita" }, " Quantidade bloqueada")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "MATRIZ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "PRINCIPAL")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-alinhar-direita" }, "200")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-alinhar-direita" }, "0")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "MATRIZ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "PRINCIPAL")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-alinhar-direita" }, "200")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-alinhar-direita" }, "0")
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes-titulo" }, "CÓDIGOS/IDENTIFICAÇÃO")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Código de barras")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "8848181818 , 18184919191917")
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Código Personalizado")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "14141414")
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Código Balança")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "14141414")
  ])
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes-titulo" }, "CARACTERÍSTICAS")
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Voltagem")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "120v")
  ])
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Cor")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "Preto")
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Modelo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes" }, "INOX")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 1000,
      visible: _ctx.computedVisivel,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedVisivel) = $event)),
      title: "Detalhes do produto",
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_carousel, { arrows: "" }, {
              prevArrow: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_icone, { nome: "left-circle" })
                ])
              ]),
              nextArrow: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_icone, { nome: "right-circle" })
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _hoisted_18,
        _hoisted_19,
        _hoisted_20,
        _hoisted_21
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}